export default __webpack_public_path__ + "static/media/origami-bird-yellow.6576d019.png";